var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-time-picker',{attrs:{"is-range":"","step":"00:15:00","format":"HH:mm","value-format":"HH:mm","range-separator":"-","start-placeholder":"开始时间","end-placeholder":"结束时间","placeholder":"选择时间范围","use-24-hour":true,"picker-options":{
    selectableRange: '00:00-23:59', 
    
    }},model:{value:(_vm.timeData),callback:function ($$v) {_vm.timeData=$$v},expression:"timeData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }